import {SurveySelectionItemListOptions} from "../model/SurveySelectionItemListOptions";
import {SurveySelectionItemModel} from "../model/SurveySelectionItemModel";
import {BaseReadDataProvider} from "./BaseReadDataProvider";

export class SurveySelectionItemDataProvider
    extends BaseReadDataProvider<SurveySelectionItemModel, SurveySelectionItemListOptions> {

    constructor(selectionId: string) {
        super(`/survey/selections/${selectionId}/items`);
    }
}